import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

class ResetPasswordConnectErrorBoundary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      errorInfo: null,
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo,
    });
  }

  render() {
    if (this.state.errorInfo) {
      return (<Redirect to={{
        pathname: '/',
        state: {
          errorInfo: this.state.errorInfo,
        },
      }}
      />);
    }

    return this.props.children;
  }
}

export default ResetPasswordConnectErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/ResetPasswordConnectErrorBoundary/ResetPasswordConnectErrorBoundary.js